// Friendly names for the database collections listed when deleting an Aerofleet account.
// Pure module (no imports) so it can be checked on its own.
export const COLLECTION_LABELS = {
  di_aircraft: "Aeronaves",
  di_pilots: "Pilotos",
  di_instructors: "Instrutores",
  di_flights: "Voos registados",
  di_components: "Componentes das aeronaves (motor, hélice…)",
  di_maintenance_items: "Itens de manutenção",
  di_maintenance_history: "Histórico de manutenções",
  di_insurances: "Seguros",
  di_insurance_payments: "Pagamentos de seguros",
  di_alerts: "Alertas (validades e manutenções)",
  di_documents: "Documentos carregados (registos)",
  di_audit_log: "Registo de alterações (auditoria)",
  di_sync_log: "Auditorias de cadernetas realizadas",
  di_email_prefs: "Preferências de e-mail",
  di_email_log: "Histórico de e-mails enviados",
  di_reminder_log: "Lembretes enviados",
  push_subscriptions: "Dispositivos com notificações ativas",
  tenant_audit_log: "Registo de acessos recusados",
};

// "di_unknown_thing" -> "Outros dados (di_unknown_thing)": never show nothing for a new collection.
export function collectionLabel(name) {
  return COLLECTION_LABELS[name] || `Outros dados (${name})`;
}

// [[name, count], ...] -> [{name, label, count}] ordered by label.
export function labelledCollections(collections) {
  return Object.entries(collections || {})
    .map(([name, count]) => ({ name, label: collectionLabel(name), count }))
    .sort((a, b) => a.label.localeCompare(b.label, "pt"));
}
